import { render, staticRenderFns } from "./ScoreDetail.vue?vue&type=template&id=58695530&scoped=true&"
import script from "./ScoreDetail.vue?vue&type=script&lang=js&"
export * from "./ScoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./ScoreDetail.vue?vue&type=style&index=0&id=58695530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58695530",
  null
  
)

export default component.exports